export { JoraCoinIcon } from './JoraCoinIcon';
export { WhatsAppIcon } from './WhatsAppIcon';
export { LinkedinIcon } from './LinkedinIcon';
export { FacebookIcon } from './FacebookIcon';
